<template>
  <div class="footer">
    <!-- 顶部内容区：垂直堆叠三大模块（地址/电话/二维码） -->
    <div class="footer-content">
      <!-- 二维码模块 -->
      <div class="qr-card">
        <div class="card-title">SCAN FOR A FREE QUOTE</div>
        <img 
          src="https://alive-1302662846.cos.ap-nanjing.myqcloud.com/1741324738676./website.png" 
          alt="Scan to get free quote"
          class="qr-img"
        />
      </div>
      
      <!-- 地址模块 -->
      <div class="info-card">
        <div class="card-title">Head Office</div>
        <div class="card-line">3300 Steeles Ave., West, Unit 16,</div>
        <div class="card-line">Concord, Ontario</div>
        <div class="card-line">L4K 2Y4</div>
      </div>

      <!-- 电话模块 -->
      <div class="info-card">
        <div class="card-title">Telephone Numbers</div>
        <div class="card-line">Telephone: 905-738-4076</div>
        <div class="card-line">Toll Free: 1-877-5-Fridge / 1-877-537-343</div>
        <div class="card-line">Fax: 905-738-8364</div>
      </div>

    </div>

    <!-- 底部版权信息 -->
    <div class="copyright">
      ©2017 Southern Atlantic Service. All rights reserved.
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileFooter",
  data() {
    return {};
  },
};
</script>

<style scoped>
/* 全局页脚容器：固定高度，适配移动端 */
.footer {
  width: 100%;
  background-color: #595857;
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding-bottom: 15px;
  padding-top: 5px;
}

/* 顶部内容区：垂直排列，控制内边距 */
.footer-content {
  width: 90%;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  gap: 10px; /* 模块间垂直间隙，移动端更透气 */
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1); /* 底部分割线，区分内容与版权 */
}

/* 通用卡片样式：统一内边距和圆角 */
.info-card, .qr-card {
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.05); /* 浅灰背景，提升层次感 */
  border-radius: 8px;
}

/* 信息卡片（地址/电话）：左对齐 */
.info-card {
  text-align: left;
}

/* 二维码卡片：居中对齐 */
.qr-card {
  text-align: center;
}

/* 卡片标题：黄色强调，统一样式 */
.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #EEB011;
  margin-bottom: 12px;
}

/* 卡片内容：白色正文，优化行高 */
.card-line {
  font-size: 12px;
  font-weight: 400;
  color: #eee;
  line-height: 1.6; /* 提升可读性 */
  margin-bottom: 5px;
}

/* 二维码图片：控制大小，避免过大 */
.qr-img {
  width: 110px;
  height: 110px;
  border-radius: 6px;
  margin-top: 10px;
  object-fit: cover; /* 保持图片比例 */
}

/* 底部版权：轻量化样式，添加分割线 */
.copyright {
  width: 90%;
  margin: 18px auto 0;
  font-size: 11px;
  color: #aaa;
  text-align: center;
  line-height: 1.4;
}
</style>